import Vue from 'vue';
import Vuex, { MutationPayload, ActionPayload, Action } from 'vuex';

import { RootState, initialState } from './RootState';
import actions, { StoreActions } from './store.actions';
import getters from './store.getters';
import mutations, { StoreMutations } from './store.mutations';

Vue.use(Vuex);

const store = new Vuex.Store<RootState>({
  state: initialState,
  actions,
  getters,
  mutations
});

store.subscribe((mutation: MutationPayload, state: RootState) => {
  if (mutation.type === StoreMutations.SetFiltroStatoOrdini) {
    store.commit(StoreMutations.ResetLavorazioniSlimSelezionate);
  } else if (mutation.type === StoreMutations.ToggleLavorazioneSlim) {
    if (state.listaLavorazioniSelezionate.length === 1) {
      store.dispatch(
        StoreActions.GetAzioniPossibiliPerLavorazioni, 
        store.state.listaLavorazioniSelezionate.map(l => l.id)
      );
    }
  }
});

store.subscribeAction((action: ActionPayload, state: RootState) => {});

store.subscribeAction({
  after: (action: ActionPayload, state: RootState) => {
    if (action.type === StoreActions.EseguiAzionePerLavorazioni) {
      const idFornitore: string | number = store.getters.isUserAdmin
        ? (state.fornitore && state.fornitore.id) || ""
        : (state.currentUsr && state.currentUsr.idFornitore) || "";
      
      store.dispatch(
        StoreActions.GetLavorazioniFornitore, 
        idFornitore
      );
    } else if (action.type === StoreActions.GetLavorazioniFornitore) {
      store.commit(StoreMutations.ResetLavorazioniSlimSelezionate);
    }
  }
});

export default store;